module.exports = __webpack_public_path__ + "img/MapThumb_Maze.f735fdca.webp";